import React from 'react';

import { scrollToElement } from 'helpers';
import { getMenuLinks } from 'helpers/get-menu-links';

export const MenuLinks = () => {
  const isHomePage = () => {
    const url = typeof window !== 'undefined' ? window.location.href : '';

    return url.split('/').at(-1) === '' || url.split('/').at(-1)?.includes('#');
  };

  const menu = getMenuLinks();

  return (
    <ul className="footer-menu-links-list footer-item-first">
      {Array.from(menu).map(([key]) => {
        return (
          key.link && (
            <li key={key.id}>
              <a
                href={key.link.uri}
                className="menu-link"
                key={key.id}
                onClick={(e) => {
                  if (isHomePage() && key.link?.anchor) {
                    scrollToElement(key.link?.anchor || '#flow', e);
                  }
                }}
              >
                {key.title}
              </a>
            </li>
          )
        );
      })}
    </ul>
  );
};
